<script setup>
	import { ref, computed } from 'vue';
	import { DsText, DsIcon } from '@coloplast/design-system';

	const props = defineProps({
		vm: {
			type: Object,
			default: () => {},
		},
	});

	const isHidden = ref(true);

	const dynamicIcon = computed(() => {
		if (isHidden.value) {
			return 'chevron-down';
		}
		else {
			return 'chevron-up';
		}
	})

	function toggleVisibility() {
		isHidden.value = !isHidden.value;
	}
</script>

<template>
	<div
		v-if="props.vm.CurrentPage?.SeeAlternativeDatesLabel && props.vm.CurrentPage?.SimilarEventsContentArea"
		class="c-alternative-date__container"
	>
		<div
			class="c-alternative-date__navigation-wrapper"
			@click="toggleVisibility"
		>
			<div class="c-alternative-date__navigation">
				<DsIcon
					icon-name="calendar"
					size="lg"
				>
				</DsIcon>
				<DsText
					html-element="h4"
					text-type="heading-lg"
				>
					{{ props.vm.CurrentPage.SeeAlternativeDatesLabel }}
				</DsText>
			</div>
			<DsIcon
				:icon-name="dynamicIcon"
				size="lg"
			>
			</DsIcon>
		</div>
		<section
			class="c-alternative-date__section"
			:style="{ display: isHidden ? 'none' : 'block' }"
			data-testid="hidden-section"
		>
			<slot></slot>
		</section>
	</div>
</template>
